import React, { useState, useEffect } from "react";
import CustomInput from "../../../Components/InputCompo/CustomInput";
import CustomSelection from "../../../Components/SelectionComp/CustomSelection";
import { ParagraphComp } from "../../../Components/ParagraphComp/ParagraphComp";
import HeaderCompo from "../../../Components/HeaderComp/HeaderCompo";
import ButtonComp from "../../../Components/ButtonComp/ButtonComp";
import { useMutation, useQuery } from "@tanstack/react-query";
import { InputCompo } from "../../../Components/InputCompo/InputCompo";
import * as Yup from "yup";
import { FieldArray, Form, Formik, useFormikContext } from "formik";
import { allCountries } from "../RegistrationDatas";
import CustomFileInput from "../../../Components/InputCompo/CustomFileInput";
import { m } from "framer-motion";
import { fadeIn } from "../../../Functions/GlobalAnimations";
import { enqueueSnackbar } from "notistack";
import {
  BronzeSectionSubPost,
  RiskSection4Get,
  RiskSection4Post,
  editRegistration
} from "../../../Store/auth/register";
import MultipleSelect from "../../../Components/SelectionComp/MultipleSelect";
import CustomTextarea from "../../../Components/textareaComp/CustomTextarea";
import Loading from "../../../Components/Loader/Loading";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import AddCommentIcon from '@mui/icons-material/AddComment';
import CloseIcon from '@mui/icons-material/Close';
import ModalComp from '../../../Components/ModalComp'
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
 
const ExternalReferences = ({ setSubTabs }) => {
  const [selectedRows, setSelectedRows] = useState([]);
  const gsnNoFromStorage = localStorage.getItem("gsn_no");
  const application_no = localStorage.getItem('RegKey')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { isLoading: fieldLoading, data: questions } = useQuery({
    queryKey: "riskApiSec4",
    queryFn: () => RiskSection4Get(gsnNoFromStorage ? gsnNoFromStorage : ""),
    cacheTime: 1000 * 60 * 5,
    staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });

  if (!gsnNoFromStorage) {
    setSubTabs({ "PAN and Legal Registration": true });
  }

  // validations for fields

  const modelSchema = Yup.object({
    normalFields: Yup.object(
      questions?.documents?.reduce((schema, fields) => {
        let fieldValidation = Yup.string();
        // if (fields.type.toLowerCase() !== "section") {

        // Check if the field has a dependent question with a condition
        if (fields.depend_question && fields.condition) {
          fieldValidation = fieldValidation.test(
            "dependent-condition",
            `${fields.question} is required when the condition is met`,
            function (value) {
              const { parent } = this;
              const dependentValue = parent[fields.depend_question];

              // Evaluate the condition using evaluateCondition function
              const isConditionMet = evaluateCondition(
                dependentValue,
                fields.condition,
                fields.value
              );

              // If condition is true, apply required validation, otherwise allow optional
              return isConditionMet ? !!value : true;
            }
          );
        }

        // Apply different validation rules based on the field's validation type
        if (
          fields.validation.toLowerCase() === "email" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.matches(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            "Invalid email address"
          );
        } else if (fields.validation.toLowerCase() === "pan") {
          fieldValidation = fieldValidation.matches(
            /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
            "Invalid PAN Number. It should be in the format: ABCDE1234F."
          );
        } else if (fields.validation.toLowerCase() === "pincode") {
          fieldValidation = fieldValidation.matches(
            /^\d{4}$|^\d{6}$/,
            "PIN code must be exactly 6 digits"
          );
        } else if (fields.validation.toLowerCase() === "areacode") {
          fieldValidation = fieldValidation.matches(
            /^(123|456|789)$/,
            "Incorrect area code"
          );
        } else if (fields.type.toLowerCase() === "multiselect dropdown") {
          fieldValidation = Yup.array();
        } else if (fields.validation.toLowerCase() === "website") {
          fieldValidation = fieldValidation.url("Please enter a valid URL");
        } else if (fields.validation.toLowerCase() === "mobile") {
          fieldValidation = fieldValidation.matches(
            /^(?:[0-9]{10}|[0-9]{7})$/,
            "Invalid contact number"
          );
        } else if (fields.type.toLowerCase() === "attach") {
          fieldValidation = Yup.object();
        } else if (fields.validation.toLowerCase() === "darpan") {
          fieldValidation = fieldValidation.test(
            "is-valid-darpan",
            " Darpan Id should be in the format: XX/1234/1234567",
            (value) =>
              value?.toUpperCase() === "NA" ||
              /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
          );
        } else if (
          fields.validation.toLowerCase() === "password" &&
          !fields.depend_question
        ) {
          fieldValidation = fieldValidation.min(
            8,
            "Password must be at least 8 characters long"
          );
        }

        // Mark field as required based on the `mandatory` flag if condition is not applicable
        if (
          !fields.depend_question &&
          fields.type.toLowerCase() !== "section" &&
          fields?.mandatory === 1
        ) {
          fieldValidation = fieldValidation.required(
            `${fields?.question} is required`
          );
        }

        // Assign validation schema for the field
        schema[fields?.question_no] = fieldValidation;
        return schema;
        // }
      }, {})
    ),
    ...questions?.documents?.reduce((sectionSchemas, fields) => {
      if (fields.type.toLowerCase() === "section") {
        sectionSchemas[fields.template] = Yup.array().of(
          Yup.object(
            fields.sub_questions.reduce((subSchema, subField) => {
              let subFieldValidation = Yup.string();

              if (subField.depend_question && subField.condition) {
                subFieldValidation = subFieldValidation.test(
                  "dependent-condition",
                  `${subField.question} is required when the condition is met`,
                  function (value) {
                    const { parent } = this;
                    const dependentValue = parent[subField.depend_question];

                    // Evaluate the condition using evaluateCondition function
                    const isConditionMet = evaluateCondition(
                      dependentValue,
                      subField.condition,
                      subField.value
                    );

                    // If condition is true, apply required validation, otherwise allow optional
                    return isConditionMet ? !!value : true;
                  }
                );
              }

              // Similar logic for sub-questions (optional)
              if (subField.validation.toLowerCase() === "email") {
                subFieldValidation = subFieldValidation.matches(
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  "Invalid email address"
                );
              } else if (subField.validation.toLowerCase() === "pan") {
                subFieldValidation = subFieldValidation.matches(
                  /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                  "Invalid PAN Number. It should be in the format: ABCDE1234F."
                );
              } else if (subField.type.toLowerCase() === "attach") {
                subFieldValidation = Yup.object();
              } else if (subField.validation.toLowerCase() === "pincode") {
                subFieldValidation = subFieldValidation.matches(
                  /^\d{4}$|^\d{6}$/,
                  "PIN code must be exactly 6 digits"
                );
              } else if (subField.validation.toLowerCase() === "mobile") {
                subFieldValidation = subFieldValidation.matches(
                  /^(?:[0-9]{10}|[0-9]{7})$/,
                  "Invalid contact number"
                );
              }

              if (subField.mandatory === 1) {
                subFieldValidation = subFieldValidation.required(
                  `${subField.question} is required`
                );
              }

              subSchema[subField.question_no] = subFieldValidation;
              return subSchema;
            }, {})
          )
        );
      }
      return sectionSchemas;
    }, {}),
  });

  // formik for submission fields

  const handleCreateSuccess = () => {
    enqueueSnackbar("success!", { variant: "success" });
  };

  const handleCreateError = (error) => {
    if (error?.response?.data.status_code >= 500) {
      enqueueSnackbar(error?.response?.data?.status_message, {
        variant: "error",
      });
    } else {
      enqueueSnackbar(error?.response?.data?.message || error?.message, {
        variant: "error",
      });
    }
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };

  const {
    mutate: submitInitialReg,
    data: regFinalData,
    isPending: mainRegistration,
  } = useMutation({
    mutationFn: RiskSection4Post,
    ...createFarmerMutationOptions,
  });

  const attachFile = (e, setFieldValue) => {
    if (!e.target.files || e.target.files.length === 0) {
      setFieldValue(e.target.name, "");
      return; // Prevent further execution if no file is selected
    }
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setFieldValue(name, {
          attach_file: base64String,
          file_name: file.name,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const evaluateCondition = (value1, condition, value2) => {
    switch (condition) {
      case "==":
        return value1 == value2; // Using loose equality as per original suggestion
      case "===":
        return value1 === value2;
      case "!==":
        return value1 !== value2;
      case ">":
        return value1 > value2;
      case "<":
        return value1 < value2;
      case ">=":
        return value1 >= value2;
      case "<=":
        return value1 <= value2;
      default:
        return false;
    }
  };

  const createInitialValues = () => {
    if (questions?.docs_answers?.length > 0) {
      return questions.docs_answers.reduce((values, field) => {
        if (field.type.toLowerCase() === "section") {
          // Initialize section with template name as an array of objects
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                if (Field.type.toLowerCase() === "multiselect dropdown") {
                  tempData[index][Field?.question_no] =
                    Field?.answer?.split(",") || [];
                } else if (Field?.type.toLowerCase() === "attach") {
                  tempData[index][Field?.question_no] = {
                    file_name: Field?.upload_document,
                  };
                } else {
                  tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
                }
              });
            });
            values[field.question] = values[field.question] || tempData; // Ensure array initialization
          } else {
            values[field.question] = values[field.question] || [{}]; // Ensure array initialization
            values[field.question].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        } else {
          // Normal fields, assign to `normalFields`
          values.normalFields = values.normalFields || {};
          if (field?.question_no) {
            if (field.type.toLowerCase() === "multiselect dropdown") {
              values.normalFields[field.question_no] =
                field?.answer?.split(",") || [];
            } else if (field?.type.toLowerCase() === "attach") {
              values.normalFields[field.question_no] = {
                file_name: field?.upload_document,
              };
            } else {
              values.normalFields[field.question_no] = field?.answer || ""; // Ensure default empty value
            }
          }
        }
        return values;
      }, {});
    } else {
      return questions?.documents?.reduce((values, field) => {
        values.normalFields = values.normalFields || {};
        values.normalFields[field?.question_no] = "";

        if (field.type.toLowerCase() === "section") {
          if (field?.answer?.length > 0) {
            const tempData = [];
            field.answer.forEach((Row, index) => {
              Row.forEach((Field) => {
                if (!tempData[index]) tempData[index] = {}; // Ensure initialization

                tempData[index][Field?.question_no] = Field?.answer || ""; // Ensure default empty value
              });
            });
            values[field.question] = values[field.question] || tempData; // Ensure array initialization
          } else {
            values[field.question] = values[field.question] || [{}]; // Ensure array initialization
            values[field.question].forEach((row) => {
              field?.sub_questions?.forEach((subField) => {
                row[subField?.question_no] =
                  subField?.question === "Country Code" ? "+91 - India" : "";
              });
            });
          }
        }
        return values;
      }, {});
    }
  };
  const toggleAllRows = (e, values, template) => {
    const isChecked = e.target.checked;
    setSelectedRows(
      isChecked
        ? { [template]: values?.[template]?.map((_, index) => index) }
        : []
    );
  };

  const toggleRowSelection = (rowIndex, template) => {
    setSelectedRows((prevSelected) => {
      // Ensure prevSelected[template] is initialized as an array
      const selectedRowsForTemplate = prevSelected?.[template] || [];

      return {
        ...prevSelected,
        [template]: selectedRowsForTemplate.includes(rowIndex)
          ? selectedRowsForTemplate.filter((index) => index !== rowIndex)
          : [...selectedRowsForTemplate, rowIndex],
      };
    });
  };

  const deleteSelectedRows = (remove, template) => {
    selectedRows?.[template].sort((a, b) => b - a); // Sort in descending order to avoid index shifting
    selectedRows?.[template].forEach((index) => remove(index));
    setSelectedRows([]); // Clear selection after deletion
  };

  const DisplayFormikValues = () => {
    const { values, errors } = useFormikContext();

    return null; // You can return JSX or null if you just want to log the values
  };


  const SubmitData = (values) => {
    let tempData = values?.["normalFields"];
    questions?.documents?.map((ele) => {
      if (ele?.type?.toLowerCase() === "section" && values?.[ele.template]) {
        submitTable(gsnNoFromStorage, {
          [ele.template]: values?.[ele.template],
        });
      }
    });

    const FinalData = questions?.documents?.map((fields) => {
      if (fields?.type?.toLowerCase() === "attach") {
        return {
          question_no: fields?.question_no,
          attach_file: tempData?.[fields?.question_no]?.attach_file,
          file_name: tempData?.[fields?.question_no]?.file_name,
        };
      } else if (fields?.type.toLowerCase() === "number") {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no]}`,
        };
      } else if (fields?.type.toLowerCase() === "checkbox") {
        return {
          question_no: fields?.question_no,
          answer: `${tempData[fields?.question_no] ? "Y" : "N"}`,
        };
      } else if (
        fields?.type.toLowerCase() === "multiselect dropdown" &&
        tempData?.[fields?.question_no]
      ) {
        return {
          question_no: fields?.question_no,
          answer: `${tempData?.[fields?.question_no].map((ele) => {
            return ele;
          })}`,
        };
      } else {
        return {
          question_no: fields?.question_no,
          answer: tempData[fields?.question_no],
        };
      }
    });

    const currentDate = new Date().toISOString().split("T")[0];
    const structuredData = {
      args: {
        name: gsnNoFromStorage,
        section_last_updated_on: currentDate,
        external_references_question_answers: FinalData,
      },
    };

    submitInitialReg(structuredData);
  };


  const multiSelectedValues = (name, question_no, value, setFieldValue) => {
    setFieldValue(name, value);
  };

  const submitTable = async (gsn, data) => {
    if (gsn) {
      try {
        const sections = questions?.documents?.filter(
          (ele) => ele.type.toLowerCase() === "section"
        );
        // Use forEach to iterate since we're not using the return value
        await Promise.all(
          sections.map(async (Sec) => {
            let passedValues = {
              args: {
                gsn_num: gsn,
                main_question_no: Sec?.question_no,
                question_answers: [],
              },
            };
            if (Sec?.template && data?.[Sec?.template]) {
              data?.[Sec?.template].forEach((ele, index) => {
                let tempQuestion_answers = [];
                Sec.sub_questions.forEach((Sub) => {
                  if (
                    (Sub.type.toLowerCase() === "attach" &&
                      ele[Sub.question_no]) ||
                    (Sub.type.toLowerCase() === "attach" &&
                      ele[Sub.question_no] === "")
                  ) {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      file_name: ele[Sub.question_no]?.file_name || "",
                      attach_file: ele[Sub.question_no]?.attach_file || "",
                    });
                  } else if (
                    Sub.type.toLowerCase() === "multiselect dropdown" &&
                    ele[Sub.question_no]
                  ) {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      answer: `${ele[Sub.question_no].map((ele) => {
                        return ele;
                      })}`,
                    });
                  } else {
                    tempQuestion_answers.push({
                      question_no: Sub.question_no,
                      answer: ele[Sub.question_no],
                    });
                  }
                  passedValues.args.question_answers[index] =
                    tempQuestion_answers;
                });
              });
            }

            // Ensure the API call only happens if there are question answers
            if (
              passedValues.args.question_answers.length > 0 &&
              passedValues.args.question_answers.some((ele) =>
                ele.some((Qn) => Qn.answer || Qn.attach_file)
              )
            ) {
              await submitSubReg(passedValues); // Await the mutation function
            }
          })
        );
      } catch (error) { }
    }
  };

  const {
    mutateAsync: submitSubReg, // Use mutateAsync to work with async/await
    isPending: subLoading,
  } = useMutation({
    mutationFn: BronzeSectionSubPost,
    ...createFarmerMutationOptions,
  });

  const OpenModal = (name, data, values, type, template, index, sub_question_num, subQuestion) => {
    setIsModalOpen({ [name]: true, data, values, type: type, index: index, template: template, sub_question_num: sub_question_num, subQuestion })
  }
  console.log("isModalOpen>>>>", isModalOpen)
  const CloseModal = () => {
    if (!editLoading) {
      setIsModalOpen('')
    }
  }


  const updateValues = async (values) => {
    try {
      console.log("isModalOpen>>>>", isModalOpen)
      const currentDate = await new Date()
      let structuredData = ''
      if (isModalOpen?.type?.toLowerCase() === 'section') {
        const PreviousData = questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index].find(ans => ans.question_no === isModalOpen?.data.question_no)
        structuredData = await
          {
            args: {
              gsn_number: gsnNoFromStorage,
              date_and_time: formatDateTime(currentDate),
              gsi_id: application_no,
              question_id: isModalOpen?.sub_question_num,
              subquestion_id: isModalOpen?.data?.question_no,
              subquestion_previous_answer: PreviousData?.answer,
              subquestion_edited_answer: isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown" ?
                `${values?.[isModalOpen?.data?.question_no].map(ele => { return ele })}` : values?.[isModalOpen?.data?.question_no],
              subquestion_text: isModalOpen?.data?.question,
              question_text: isModalOpen?.subQuestion,
              section_name: 'Organisational Resilience'
            }
          }


      } else {
        structuredData = await
          {
            args: {
              gsn_number: gsnNoFromStorage,
              date_and_time: formatDateTime(currentDate),
              gsi_id: application_no,
              question_id: isModalOpen?.data?.question_no,
              question_text: isModalOpen?.data?.question,
              previous_answer:
                values?.normalFields?.[isModalOpen?.data?.question_no] ||
                (questions?.docs_answers?.length > 0 &&
                  questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || '',
              edited_answer:
                isModalOpen?.data?.type?.toLowerCase() === "multiselect dropdown" ?
                  `${values?.[isModalOpen?.data?.question_no].map(ele => { return ele })}`
                  :
                  values?.[isModalOpen?.data?.question_no],
              section_name: 'Organisational Resilience'
            }
          }
      }
      console.log("structuredData>>>>", structuredData)

      await editData(structuredData)

    } catch (error) {

    }
  };
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);

    // Extract YYYY-MM-DD
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure two digits
    const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits

    // Extract HH:MM:SS in 24-hour format
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const editModalSchema = Yup.object().shape({
    [isModalOpen?.data?.question_no]: (() => {
      let validation = Yup.string();

      // Check if isModalOpen?.data is defined
      if (!isModalOpen?.data) return validation;

      const fieldType = isModalOpen.data.type?.toLowerCase();
      const fieldValidation = isModalOpen.data.validation?.toLowerCase();

      // Apply validation based on `validation` property
      if (fieldValidation === 'email' && !isModalOpen.data?.depend_question) {
        validation = validation.matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          'Invalid email address'
        );
      }
      else if (fieldValidation === 'pan') {
        validation = validation.matches(
          /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
          "Invalid PAN Number. Format: ABCDE1234F."
        );
      }
      else if (fieldValidation === 'pincode') {
        validation = validation.matches(
          /^\d{4}$|^\d{6}$/,
          "PIN code must be exactly 4 or 6 digits"
        );
      }
      else if (fieldValidation === 'mobile') {
        validation = validation.matches(
          /^(?:[0-9]{10}|[0-9]{7})$/,
          "Invalid contact number"
        );
      }
      else if (fieldValidation === 'website') {
        validation = validation.url('Please enter a valid URL');
      }
      else if (fieldValidation === 'darpan') {
        validation = validation.test(
          'is-valid-darpan',
          'Darpan ID should be in the format: XX/1234/1234567',
          value => value?.toUpperCase() === 'NA' || /^([A-Z]{2}\/\d{4}\/\d{7})$/.test(value)
        );
      }
      else if (fieldValidation === 'password' && !isModalOpen.data?.depend_question) {
        validation = validation.min(8, "Password must be at least 8 characters long");
      }
      else if (fieldType === 'multiselect dropdown') {
        validation = Yup.array().of(Yup.string());
      }
      else if (fieldType === 'attach') {
        validation = Yup.object();
      }

      // Apply 'required' validation if `mandatory` is 1
      if (isModalOpen.data.mandatory === 1) {
        validation = validation.required(`${isModalOpen.data.question} is required`);
      }

      return validation;
    })()
  });

  const modalMultiSelectedValues = (name, values, setModalFieldValue) => {
    setModalFieldValue(name, values);
  };


  const createNewRow = (sub_questions) => {
    let newRow = {};
    sub_questions.forEach((subField) => {
      newRow[subField.question_no] = "";
    });
    return newRow;
  };
  const hasAnswerForQuestion = () => {
    if (!questions?.docs_answers?.length) return false;

    // Check if any document has at least one answer
    const hasAnyAnswer = questions?.docs_answers?.length > 0 && questions?.docs_answers?.some(doc => doc?.answer)

    // Find a document matching any template from `questions.documents`
    const doc = questions.documents
      .map(template => questions.docs_answers.find(doc => doc?.template === template?.template))
      .find(Boolean); // Find the first matching document

    // Ensure `doc` exists and `doc.answer` is a valid array before checking answers
    const isAnyAnswerFilled = Array.isArray(doc?.answer) && doc.answer.some(ele =>
      Array.isArray(ele) && ele.some(dt => dt?.answer)
    );

    return isAnyAnswerFilled || hasAnyAnswer;
  };


  const { mutate: editData, isPending: editLoading } = useMutation({
    mutationFn: editRegistration,
    ...createFarmerMutationOptions,
    onMutate: async () => {
      // Cancel the current query before mutating
      // await queryClient.cancelQueries(['Questions', application_no]);
    },
    onSuccess: () => {
      // Invalidate the query to refetch the latest data
      // queryClient.invalidateQueries(['Questions', application_no]);
    },
  });


  useEffect(() => {
    if (!editLoading) {
      setIsModalOpen('')
    }
  }, [editLoading])
  // loading questions

  if (fieldLoading || subLoading || mainRegistration) return <Loading />;

  // set default fields

  return (
    <>
      <Formik
        initialValues={createInitialValues()}
        validationSchema={modelSchema}
        enableReinitialize={true}
        onSubmit={SubmitData}
      >
        {({
          values,
          errors,
          handleChange,
          touched,
          handleBlur,
          setFieldValue,
        }) => (
          <Form className="flex flex-col gap-[30px]" action="">
            <div className="flex flex-wrap gap-[30px] justify-between w-[100%]">
              {questions?.documents.map((Fields) => (
                <>
                  {Fields?.paremeter && (
                    <div key={Fields.question_no} className="w-[100%]">
                      <HeaderCompo
                        className="text-2xl text-black"
                        text={Fields?.paremeter}
                        tagType="h3"
                      />
                    </div>
                  )}
                  {Fields.type.toLowerCase() === "text" ||
                    Fields.type.toLowerCase() === "number" ||
                    Fields.type.toLowerCase() === "date" ||
                    Fields.type.toLowerCase() === "password" ? (
                    <div
                      key={Fields.question_no}
                      className={`${evaluateCondition(
                        values?.normalFields?.[Fields?.depend_question],
                        Fields.condition,
                        Fields.value
                      ) &&
                        Fields?.depend_question &&
                        values?.normalFields?.[Fields?.depend_question]
                        ? "block"
                        : Fields?.depend_question
                          ? "hidden"
                          : "block"
                        } ${Fields?.question.toLowerCase() === "comment box"
                          ? "w-[100%]"
                          : " w-[48%]"
                        }  `}
                    >
                      <CustomInput
                        required={Fields?.mandatory > 0 ? true : false}
                        type={Fields.type.toLowerCase()}
                        name={`normalFields.${Fields.question_no}`}
                        label={Fields.question}
                        value={values?.normalFields?.[Fields.question_no]}
                        onChange={handleChange}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          values?.normalFields?.[Fields.question_no] &&
                          errors.normalFields?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "dropdown" ? (
                    <div
                      key={Fields.question_no}
                      className={`${evaluateCondition(
                        values?.normalFields?.[Fields?.depend_question],
                        Fields.condition,
                        Fields.value
                      ) &&
                        Fields?.depend_question &&
                        values?.normalFields?.[Fields?.depend_question]
                        ? "block"
                        : Fields?.depend_question
                          ? "hidden"
                          : "block"
                        } w-[48%]`}
                    >
                      <CustomSelection
                        required={Fields?.mandatory > 0 ? true : false}
                        options={Fields?.options}
                        value={values?.normalFields?.[Fields.question_no]}
                        onChange={handleChange}
                        name={`normalFields.${Fields.question_no}`}
                        label={Fields?.question}
                        noSort={true}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          values?.normalFields?.[Fields.question_no] &&
                          errors?.normalFields?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "text area" ? (
                    <div
                      key={Fields.question_no}
                      className={`${evaluateCondition(
                        values?.normalFields?.[Fields?.depend_question],
                        Fields.condition,
                        Fields.value
                      ) &&
                        Fields?.depend_question &&
                        values?.normalFields?.[Fields?.depend_question]
                        ? "block"
                        : Fields?.depend_question
                          ? "hidden"
                          : "block"
                        } ${Fields?.question.toLowerCase() === "comment box"
                          ? "w-[100%]"
                          : " w-[48%]"
                        }  `}
                    >
                      <CustomTextarea
                        required={Fields?.mandatory > 0 ? true : false}
                        type={Fields.type.toLowerCase()}
                        name={`normalFields.${Fields.question_no}`}
                        label={Fields.question}
                        value={values?.normalFields?.[Fields.question_no]}
                        onChange={handleChange}
                      />
                      <ParagraphComp
                        className="text-[red] text-[10px] px-[8px] mt-1"
                        text={
                          values?.normalFields?.[Fields.question_no] &&
                          errors.normalFields?.[Fields.question_no]
                        }
                      />
                      <ParagraphComp
                        className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                        text={Fields.description}
                      />
                    </div>
                  ) : Fields?.type.toLowerCase() === "multiselect dropdown" ? (
                    <div
                      key={Fields.question_no}
                      className={` ${Fields?.description?.length > 150
                        ? "w-[100%]"
                        : " w-[48%]"
                        } `}
                    >
                      <MultipleSelect
                        required={Fields?.mandatory > 0 ? true : false}
                        options={
                          Fields?.question_no === "DRQ-00077"
                            ? Fields?.options?.filter((ele) =>
                              values?.["normalFields"]?.[
                                "DRQ-00076"
                              ]?.includes(ele.value)
                            )
                            : Fields?.options
                        }
                        maxSelect={Fields.validation === "Select Upto 3" && 3}
                        mappingKey={
                          Fields?.question_no !== "DRQ-00077"
                            ? "option"
                            : "option"
                        } // Pass mapping key if needed
                        // formik={formik} // Pass the formik instance
                        onValueChange={(name, values) =>
                          multiSelectedValues(
                            name,
                            Fields.question_no,
                            values,
                            setFieldValue
                          )
                        }
                        selectedValues={
                          values?.normalFields?.[Fields?.question_no] || []
                        }
                        name={`normalFields.${Fields?.question_no}`}
                        label={Fields?.question}
                        noSort={true}
                      />
                    </div>
                  ) : Fields.type.toLowerCase() === "attach" ? (
                    <div
                      key={Fields.question_no}
                      className={`${evaluateCondition(
                        values?.normalFields?.[Fields?.depend_question],
                        Fields.condition,
                        Fields.value
                      ) &&
                        Fields?.depend_question &&
                        values?.normalFields?.[Fields?.depend_question]
                        ? "block"
                        : Fields?.depend_question
                          ? "hidden"
                          : "block"
                        } ${Fields?.question?.length > 80 ? "w-[100%]" : " w-[48%]"
                        }`}
                    >
                      <div>
                        <>
                          <CustomFileInput
                            required={Fields?.mandatory > 0 ? true : false}
                            onChange={(e) => attachFile(e, setFieldValue)}
                            value={
                              values?.normalFields?.[Fields?.question_no]
                                ?.file_name
                            }
                            name={`normalFields.${Fields.question_no}`}
                            label={Fields?.question}
                          />
                          <ParagraphComp
                            className="text-[red] text-[10px] px-[8px] mt-1"
                            text={
                              values?.normalFields?.[Fields.question_no] &&
                              errors.normalFields?.[Fields.question_no]
                            }
                          />
                          <ParagraphComp
                            className="mt-[8px] text-[#5A5A5A] text-sm px-[8px]"
                            text={Fields.description}
                          />{" "}
                        </>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* {
                                        Fields.type.toLowerCase() === 'section' ?
                                            <>
                                                <div key={Fields.question_no} className='w-[100%]' style={{ marginBottom: '40px', }}>


                                                    <FieldArray name={Fields.template}>
                                                        {({ push, remove }) => (
                                                            <>
                                                                <div className='w-[100%]'>
                                                                    <div className='p-[20px] w-[100%] border-2 rounded-t-xl flex items-center justify-between'>
                                                                        <HeaderCompo className='text-xl text-black mt-0 m-0' tagType='h3' text={Fields.template} />
                                                                        <div className='flex gap-[20px]'>
                                                                            {selectedRows?.[Fields?.template]?.length > 0 &&
                                                                                <m.div {...fadeIn}>
                                                                                    < ButtonComp type='button' onClick={() => deleteSelectedRows(remove, Fields.template)} text='Delete' className='px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px]' />
                                                                                </m.div>
                                                                            }
                                                                            <ButtonComp type='button' onClick={() => push(createInitialValues(Fields.sub_questions)?.[Fields.template][0])} text='Add' className='px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px]' />
                                                                        </div>
                                                                    </div>
                                                                    <table className='border-2 text-[#667085] rounded-t-2xl w-[100%]'>
                                                                        <thead>
                                                                            <tr className='border-b-2'>
                                                                                <th className='p-[10px]'>

                                                                                    <div className='w-[20px]'>
                                                                                        {values?.[Fields?.template]?.length > 0 ?
                                                                                            <InputCompo
                                                                                                type="checkbox"
                                                                                                className='w-[20px] h-[20px]'
                                                                                                checked={values?.[Fields?.template]?.length > 0 && selectedRows?.[Fields?.template]?.length === values?.[Fields?.template]?.length}
                                                                                                onChange={(e) => toggleAllRows(e, values, Fields?.template)}
                                                                                            />
                                                                                            : ''}
                                                                                    </div>
                                                                                </th>
                                                                                <th className='p-[10px]'>No.</th>
                                                                                {Fields.sub_questions.map((subQ) => (
                                                                                    <th key={subQ.question_no} className='p-[10px]'>
                                                                                        {subQ.question}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {values?.[Fields.template]?.map((row, rowIndex) => (
                                                                                <tr key={rowIndex} className='border-b-2'>
                                                                                    <td className='p-[10px]'>
                                                                                        <InputCompo
                                                                                            className='w-[20px] h-[20px]'
                                                                                            type="checkbox"
                                                                                            checked={selectedRows?.[Fields?.template]?.includes(rowIndex)}
                                                                                            onChange={() => toggleRowSelection(rowIndex, Fields.template)}
                                                                                        />
                                                                                    </td>
                                                                                    <td className='p-[10px]'>
                                                                                        {rowIndex + 1}
                                                                                    </td>
                                                                                    {Fields.sub_questions.map((subQ) => (
                                                                                        <td key={subQ.question_no} className='p-[10px]'>
                                                                                            {subQ.type === 'Dropdown' ? (
                                                                                                <CustomSelection
                                                                                                    required={subQ?.mandatory > 0 ? true : false}
                                                                                                    imgKey='flag'
                                                                                                    exDataKey={subQ?.question === 'Country Code' ? 'label' : undefined}
                                                                                                    disabled={subQ?.depend_question
                                                                                                        ? !evaluateCondition(row?.[subQ?.depend_question], subQ.condition, subQ.value)
                                                                                                        : false}
                                                                                                    mappingKey={subQ?.question === 'Country Code' ? 'phone' : undefined}
                                                                                                    options={subQ?.question === 'Country Code' ? allCountries : subQ?.options}
                                                                                                    onChange={handleChange}
                                                                                                    onBlur={handleBlur}
                                                                                                    name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                                                                    value={row?.[subQ.question_no]} // Ensure empty string for no value
                                                                                                    label="Select"
                                                                                                    noSort={true}
                                                                                                />
                                                                                            ) : (subQ.type === 'Text' || subQ.type === 'Number') ? (
                                                                                                <CustomInput
                                                                                                    required={subQ?.mandatory > 0 ? true : false}
                                                                                                    disabled={subQ?.depend_question ? !evaluateCondition(row?.[subQ?.depend_question], subQ.condition, subQ.value) ? true : false : ''}
                                                                                                    options={subQ?.options}
                                                                                                    type={subQ?.type?.toLowerCase()}
                                                                                                    onChange={handleChange}
                                                                                                    onBlur={handleBlur}
                                                                                                    name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                                                                    value={row[subQ.question_no]}
                                                                                                    label={subQ.question === 'Telephone Number' ? 'Enter the number here' : 'Enter'} />
                                                                                            ) :
                                                                                                (subQ.type.toLowerCase() === 'attach')
                                                                                                    ? (
                                                                                                        <CustomFileInput
                                                                                                            required={subQ?.mandatory > 0 ? true : false}
                                                                                                            onChange={(e) => attachFile(e, setFieldValue)}
                                                                                                            name={`${Fields?.template}.${rowIndex}.${subQ.question_no}`}
                                                                                                            value={row[subQ.question_no].file_name}
                                                                                                            label={subQ.question} />

                                                                                                    )
                                                                                                    :
                                                                                                    (subQ.type.toLowerCase() === 'multiselect dropdown')
                                                                                                        ? (
                                                                                                            <MultipleSelect
                                                                                                                maxSelect={Fields.validation === 'Select Upto 3' && 3}
                                                                                                                required={subQ?.mandatory > 0 ? true : false}
                                                                                                                options={subQ?.options}
                                                                                                                mappingKey="option" // Pass mapping key if needed
                                                                                                                // onValueChange={(name, values) => selectedValues(name, values, index)}
                                                                                                                selectedValues={values?.[subQ?.question_no] || []}
                                                                                                                name={subQ.question_no}
                                                                                                                label={subQ?.question}
                                                                                                                noSort={true}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            ''
                                                                                                        )}

                                                                                            {errors?.[Fields.template]?.[rowIndex][subQ.question_no] &&
                                                                                                row[subQ.question_no] &&
                                                                                                <div className="error">
                                                                                                    {errors?.[Fields.template][rowIndex][subQ.question_no]}
                                                                                                </div>}
                                                                                        </td>
                                                                                    ))}
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        )}                                                       
                                                    </FieldArray>
                                                </div>
                                            </>
                                            : ''

                                    } */}

                  {Fields.type.toLowerCase() === "section" ? (
                    <>
                      <div
                        key={Fields.question_no}
                        className={`w-[100%] ${evaluateCondition(
                          values?.normalFields?.[Fields?.depend_question],
                          Fields.condition,
                          Fields.value
                        ) &&
                          Fields?.depend_question &&
                          values?.normalFields?.[Fields?.depend_question]
                          ? "block"
                          : Fields?.depend_question
                            ? "hidden"
                            : "block"
                          } `}
                        style={{ marginBottom: "40px" }}
                      >
                        <FieldArray name={Fields.question}>
                          {({ push, remove }) => (
                            <>
                              <div className="w-[100%]">
                                <div className="p-[20px] w-[100%] border-2 rounded-t-xl flex items-center justify-between">
                                  <div>
                                    <HeaderCompo
                                      className="text-xl text-black mt-0 m-0"
                                      tagType="h3"
                                      text={Fields.question}
                                    />
                                    <HeaderCompo
                                      className="text-sm text-black mt-1 m-0"
                                      tagType="h3"
                                      text={Fields.description}
                                    />
                                  </div>
                                  <div className="flex gap-[20px]">
                                    {selectedRows?.[Fields?.question]?.length >
                                      0 && (
                                        <m.div {...fadeIn}>
                                          <ButtonComp
                                            type="button"
                                            onClick={() =>
                                              deleteSelectedRows(
                                                remove,
                                                Fields.question
                                              )
                                            }
                                            text="Delete"
                                            className="px-[20px] h-[40px] text-[#004878] border-2 bg-transparent border-[#004878] rounded-full py-[5px] whitespace-nowrap"
                                          />
                                        </m.div>
                                      )}
                                    {/* {!hasAnswerForQuestion() && */}
                                      <ButtonComp
                                        type='button'
                                        onClick={() => push(createNewRow(Fields?.sub_questions))}// Push an empty row
                                        text='Add'
                                        className='px-[20px] h-[40px] text-white bg-[#004878] rounded-full py-[5px] whitespace-nowrap'
                                      />
                                    {/* } */}
                                  </div>
                                </div>
                                <div className="overflow-scroll">
                                  <table className="border-2 text-[#667085] rounded-t-2xl w-[100%]">
                                    <thead>
                                      <tr className="border-b-2">
                                        <th className="p-[10px]">
                                          <div className="w-[20px]">
                                            {values?.[Fields?.question]
                                              ?.length > 0 ? (
                                              <InputCompo
                                                type="checkbox"
                                                className="w-[20px] h-[20px]"
                                                checked={
                                                  values?.[Fields?.question]
                                                    ?.length > 0 &&
                                                  selectedRows?.[
                                                    Fields?.question
                                                  ]?.length ===
                                                  values?.[Fields?.question]
                                                    ?.length
                                                }
                                                onChange={(e) =>
                                                  toggleAllRows(
                                                    e,
                                                    values,
                                                    Fields?.question
                                                  )
                                                }
                                              />
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </th>
                                        <th className="p-[10px] w-[50px]">
                                          No.
                                        </th>
                                        {Fields.sub_questions.map((subQ) => (
                                          <th
                                            key={subQ.question_no}
                                            className="p-[10px] min-w-[250px]"
                                          >
                                            {subQ.question}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {values?.[Fields.question]?.map(
                                        (row, rowIndex) => (
                                          <tr
                                            key={rowIndex}
                                            className="border-b-2"
                                          >
                                            <td className="p-[10px]">
                                              <InputCompo
                                                className="w-[20px] h-[20px]"
                                                type="checkbox"
                                                checked={selectedRows?.[
                                                  Fields?.question
                                                ]?.includes(rowIndex)}
                                                onChange={() =>
                                                  toggleRowSelection(
                                                    rowIndex,
                                                    Fields.question
                                                  )
                                                }
                                              />
                                            </td>
                                            <td className="p-[10px] min-w-[50px]">
                                              {rowIndex + 1}
                                            </td>
                                            {Fields.sub_questions.map(
                                              (subQ) => (
                                                <td
                                                  key={subQ.question_no}
                                                  className="p-[10px] min-w-[350px] max-w-[250px]"
                                                >
                                                  {subQ.type === "Dropdown" ? (
                                                    <div className="flex gap-[10px] ">
                                                      <div className="w-[100%]">


                                                        <CustomSelection
                                                          required={
                                                            subQ?.mandatory > 0
                                                              ? true
                                                              : false
                                                          }
                                                          imgKey="flag"
                                                          exDataKey={
                                                            subQ?.question ===
                                                              "Country Code"
                                                              ? "label"
                                                              : undefined
                                                          }
                                                          // disabled={
                                                          //   hasAnswerForQuestion(Fields, subQ) ? true :
                                                          //     subQ?.depend_question
                                                          //       ? !evaluateCondition(
                                                          //         row?.[
                                                          //         subQ
                                                          //           ?.depend_question
                                                          //         ],
                                                          //         subQ.condition,
                                                          //         subQ.value
                                                          //       )
                                                          //       : false
                                                          // }
                                                          mappingKey={
                                                            subQ?.question ===
                                                              "Country Code"
                                                              ? "phone"
                                                              : undefined
                                                          }
                                                          options={
                                                            subQ?.question ===
                                                              "Country Code"
                                                              ? allCountries
                                                              : subQ?.options
                                                          }
                                                          onChange={handleChange}
                                                          onBlur={handleBlur}
                                                          name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                          value={
                                                            row?.[subQ.question_no]
                                                          } // Ensure empty string for no value
                                                          label="Select"
                                                          noSort={true}
                                                        />
                                                      </div>
                                                      {/* {hasAnswerForQuestion(Fields, subQ) &&
                                                        <div className="flex gap-[10px] mt-[8px]">
                                                          <div
                                                            onClick={() => OpenModal('edit', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <BorderColorIcon className="text-white" />
                                                          </div>
                                                          <div
                                                            onClick={() => OpenModal('comment', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                          </div>
                                                        </div>
                                                      } */}

                                                    </div>
                                                  ) : subQ.type === "Text" ||
                                                    subQ.type === "Float" ||
                                                    subQ.type === "Number" ||
                                                    subQ.type === "Date" ? (
                                                    <div className="flex gap-[10px] ">
                                                      <CustomInput
                                                        required={
                                                          subQ?.mandatory > 0
                                                            ? true
                                                            : false
                                                        }
                                                        // disabled={
                                                        //   hasAnswerForQuestion(Fields, subQ) ? true :
                                                        //     subQ?.depend_question
                                                        //       ? !evaluateCondition(
                                                        //         row?.[
                                                        //         subQ
                                                        //           ?.depend_question
                                                        //         ],
                                                        //         subQ.condition,
                                                        //         subQ.value
                                                        //       )
                                                        //         ? true
                                                        //         : false
                                                        //       : ""
                                                        // }
                                                        // options={subQ?.options}
                                                        type={
                                                          subQ.type.toLowerCase() ===
                                                            "float"
                                                            ? "number"
                                                            : subQ.type.toLowerCase()
                                                        }
                                                        onChange={(e) => {
                                                          let value =
                                                            e.target.value;

                                                          if (
                                                            subQ.type.toLowerCase() ===
                                                            "float"
                                                          ) {
                                                            // Check if there is a decimal point and digits after it
                                                            const decimalIndex =
                                                              value.indexOf(".");

                                                            if (
                                                              decimalIndex !== -1
                                                            ) {
                                                              const decimalPart =
                                                                value.substring(
                                                                  decimalIndex + 1
                                                                );

                                                              // If more than two digits after decimal, show a warning and truncate the value
                                                              if (
                                                                decimalPart.length >
                                                                2
                                                              ) {
                                                                enqueueSnackbar(
                                                                  `${subQ?.question} can only have up to 2 decimal places`,
                                                                  {
                                                                    variant:
                                                                      "warning",
                                                                  }
                                                                );
                                                                value =
                                                                  value.substring(
                                                                    0,
                                                                    decimalIndex +
                                                                    3
                                                                  ); // Allow only 2 digits after decimal
                                                              }
                                                            }
                                                          }

                                                          e.target.value = value; // Update the input value
                                                          handleChange(e); // Continue with Formik's onChange
                                                        }}
                                                        onBlur={handleBlur}
                                                        name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                        value={
                                                          row[subQ.question_no]
                                                        }
                                                        label={
                                                          subQ.question ===
                                                            "Telephone Number"
                                                            ? "Enter the number here"
                                                            : "Enter"
                                                        }
                                                      />
                                                      {/* {hasAnswerForQuestion(Fields, subQ) &&
                                                        <div className="flex gap-[10px] mt-[8px]">
                                                          <div
                                                            onClick={() => OpenModal('edit', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <BorderColorIcon className="text-white" />
                                                          </div>
                                                          <div
                                                            onClick={() => OpenModal('comment', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                          </div>
                                                        </div>
                                                      } */}
                                                    </div>
                                                  ) : subQ.type.toLowerCase() ===
                                                    "text area" ? (
                                                    <div className="flex gap-[10px]">

                                                      <CustomTextarea
                                                        // disabled={hasAnswerForQuestion(Fields, subQ)}

                                                        required={
                                                          subQ?.mandatory > 0
                                                            ? true
                                                            : false
                                                        }
                                                        // type={Fields.type.toLowerCase()}
                                                        name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                        value={
                                                          row?.[subQ.question_no]
                                                        } // Ensure empty string for no value
                                                        onChange={handleChange}
                                                        label={"Text here"}
                                                      />
                                                      {/* {hasAnswerForQuestion(Fields, subQ) &&
                                                        <div className="flex gap-[10px] mt-[8px]">
                                                          <div
                                                            onClick={() => OpenModal('edit', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <BorderColorIcon className="text-white" />
                                                          </div>
                                                          <div
                                                            onClick={() => OpenModal('comment', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="bg-[#004878] relative h-fit rounded-full p-[8px]"
                                                          >
                                                            {Fields?.type?.toLowerCase() === 'section'
                                                              ? (
                                                                questions?.docs_answers?.length > 0 &&
                                                                Array.isArray(
                                                                  questions?.docs_answers?.find(doc => doc?.template === Fields?.template)?.answer
                                                                ) &&
                                                                questions?.docs_answers
                                                                  ?.find(doc => doc?.template === Fields?.template)
                                                                  ?.answer?.[rowIndex]
                                                                  ?.find(doc => doc?.question_no === subQ?.question_no)
                                                                  ?.comments_for_npo
                                                              ) ? (
                                                                <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                  <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                </div>
                                                              ) : null
                                                              : ''
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                          </div>
                                                        </div>
                                                      } */}
                                                    </div>
                                                  ) : subQ.type.toLowerCase() ===
                                                    "attach" ? (
                                                    <div className="flex gap-[10px]">
                                                      <CustomFileInput
                                                        // disabled={hasAnswerForQuestion(Fields, subQ)}
                                                        required={
                                                          subQ?.mandatory > 0
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={(e) =>
                                                          attachFile(
                                                            e,
                                                            setFieldValue
                                                          )
                                                        }
                                                        name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                        value={
                                                          row[subQ.question_no]
                                                            .file_name
                                                        }
                                                        label={subQ.question}
                                                      />
                                                      {/* {hasAnswerForQuestion(Fields, subQ) &&
                                                        <div className="flex gap-[10px] mt-[8px]">
                                                          <div
                                                            onClick={() => OpenModal('edit', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <BorderColorIcon className="text-white" />
                                                          </div>
                                                          <div
                                                            onClick={() => OpenModal('comment', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="bg-[#004878] relative h-fit rounded-full p-[8px]"
                                                          >
                                                            {Fields?.type?.toLowerCase() === 'section'
                                                              ? (
                                                                questions?.docs_answers?.length > 0 &&
                                                                Array.isArray(
                                                                  questions?.docs_answers?.find(doc => doc?.template === Fields?.template)?.answer
                                                                ) &&
                                                                questions?.docs_answers
                                                                  ?.find(doc => doc?.template === Fields?.template)
                                                                  ?.answer?.[rowIndex]
                                                                  ?.find(doc => doc?.question_no === subQ?.question_no)
                                                                  ?.comments_for_npo
                                                              ) ? (
                                                                <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                  <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                </div>
                                                              ) : null
                                                              : ''
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                          </div>
                                                        </div>
                                                      } */}
                                                    </div>
                                                  ) : subQ.type.toLowerCase() ===
                                                    "text area" ? (
                                                    <div className="flex gap-[10px]">


                                                      <CustomTextarea
                                                        required={
                                                          subQ?.mandatory > 0
                                                            ? true
                                                            : false
                                                        }
                                                        // type={Fields.type.toLowerCase()}
                                                        name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                        value={
                                                          row?.[subQ.question_no]
                                                        } // Ensure empty string for no value
                                                        onChange={handleChange}
                                                      />
                                                      {/* {hasAnswerForQuestion(Fields, subQ) &&
                                                        <div className="flex gap-[10px] mt-[8px]">
                                                          <div
                                                            onClick={() => OpenModal('edit', subQ, values, Fields?.type, Fields?.template, rowIndex, Fields?.question_no, Fields?.question)}
                                                            className="cursor-pointer bg-[#004878] h-fit rounded-full p-[8px]"
                                                          >
                                                            <BorderColorIcon className="text-white" />
                                                          </div>
                                                          <div
                                                            onClick={() => OpenModal('comment', Fields)}
                                                            className="bg-[#004878] relative h-fit rounded-full p-[8px]"
                                                          >
                                                            {Fields?.type?.toLowerCase() === 'section'
                                                              ? (
                                                                questions?.docs_answers?.length > 0 &&
                                                                Array.isArray(
                                                                  questions?.docs_answers?.find(doc => doc?.template === Fields?.template)?.answer
                                                                ) &&
                                                                questions?.docs_answers
                                                                  ?.find(doc => doc?.template === Fields?.template)
                                                                  ?.answer?.[rowIndex]
                                                                  ?.find(doc => doc?.question_no === subQ?.question_no)
                                                                  ?.comments_for_npo
                                                              ) ? (
                                                                <div className="absolute z-10 bg-[red] mt-[-20px] ml-[17px] rounded-full p-[1px]">
                                                                  <NotificationsActiveIcon className="text-[#ffffff]" />
                                                                </div>
                                                              ) : null
                                                              : ''
                                                            }
                                                            <AddCommentIcon className="scale-x-[-1] cursor-pointer text-white" />
                                                          </div>
                                                        </div>
                                                      } */}
                                                    </div>
                                                  ) : subQ.type.toLowerCase() ===
                                                    "multiselect dropdown" ? (
                                                    <MultipleSelect
                                                      maxSelect={
                                                        Fields.validation ===
                                                        "Select Upto 3" && 3
                                                      }
                                                      required={
                                                        subQ?.mandatory > 0 ||
                                                        evaluateCondition(
                                                          row?.[
                                                          subQ
                                                            ?.depend_question
                                                          ],
                                                          subQ.condition,
                                                          subQ.value
                                                        )
                                                      }
                                                      onValueChange={(
                                                        name,
                                                        values
                                                      ) =>
                                                        multiSelectedValues(
                                                          name,
                                                          Fields.question_no,
                                                          values,
                                                          setFieldValue
                                                        )
                                                      }
                                                      options={subQ?.options}
                                                      mappingKey="option"
                                                      selectedValues={
                                                        row[subQ.question_no] ||
                                                        []
                                                      }
                                                      name={`${Fields?.question}.${rowIndex}.${subQ.question_no}`}
                                                      label={subQ?.question}
                                                      noSort={true}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}

                                                  {errors?.[Fields.question]?.[
                                                    rowIndex
                                                  ][subQ.question_no] &&
                                                    row[subQ.question_no] && (
                                                      <div className="error">
                                                        {
                                                          errors?.[
                                                          Fields.question
                                                          ][rowIndex][
                                                          subQ.question_no
                                                          ]
                                                        }
                                                      </div>
                                                    )}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </>
                          )}
                        </FieldArray>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ))}

              <DisplayFormikValues />
            </div>
            {/* {hasAnswerForQuestion() ? (
              ""
            ) : ( */}
              <div className="flex justify-end">
                <ButtonComp
                  type="submit"
                  className="px-[20px] py-[6px] h-[40px] text-white bg-[#004878] rounded-full"
                  text="Save & Next"
                />
              </div>
            {/* )} */}
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['comment']} closeModal={CloseModal} >
              <HeaderCompo className='text-2xl mb-[10px] font-bold text-black mt-[10px] text-center' tagType={'h3'} text='Comment' />
              <ParagraphComp className='text-lg text-black text-center' >
                {isModalOpen?.type?.toLowerCase() === 'section' ?
                  ((questions?.docs_answers?.length > 0 &&
                    Array.isArray(questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer)) &&
                    questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator' :
                  (questions?.docs_answers?.length > 0 &&
                    questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.comments_for_npo) || 'No comment was added by the administrator.'}
              </ParagraphComp>
              <div className="flex justify-end">
                <ButtonComp onClick={CloseModal} type='button' className=' mt-[10px] py-[5px] px-[10px] rounded-[20px] border-2 border-[#004878] text-[#004878]'>
                  Close
                </ButtonComp>
              </div>

            </ModalComp>
            <ModalComp width={'35%'} modalIsOpen={isModalOpen?.['edit']} closeModal={CloseModal} >
              <Formik
                initialValues={{
                  [isModalOpen?.data?.question_no || 'default_question_no']: '',
                }}
                validationSchema={editModalSchema}
                onSubmit={(values) => {
                  updateValues(values, setFieldValue);
                }}
              >
                {({ values: modalValues, errors: modalErrors, handleChange, setFieldValue: setModalFieldValue }) => (
                  <Form>
                    <div className="h-auto">
                      {/* Close Button */}
                      <div className="flex justify-end">
                        <div className="cursor-pointer" onClick={CloseModal}>
                          <CloseIcon />
                        </div>
                      </div>

                      {/* Header */}
                      <HeaderCompo className="text-2xl mb-[10px] font-bold text-black mt-[10px] text-center" tagType="h3" text="Edit" />
                      <ParagraphComp className="text-lg text-black text-start" text="Question" />
                      <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' text={isModalOpen?.data?.question} />
                      {console.log("answer>>>", questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(ele => ele.question_no === isModalOpen?.data?.question_no))}
                      {(isModalOpen?.type?.toLowerCase() === 'section' ?
                        values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                        (questions?.docs_answers?.length > 0 &&
                          questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(ele => ele.question_no === isModalOpen?.data?.question_no))?.answer || '' :
                        values?.normalFields?.[isModalOpen?.data?.question_no] ||
                        (questions?.docs_answers?.length > 0 &&
                          questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer))
                        ?
                        <ParagraphComp className='text-lg mt-[10px] text-black text-start' text='Current Answer' />
                        : ''
                      }
                      <ParagraphComp className='text-md mt-[10px] text-[#3f3f3f] text-start' >
                        {isModalOpen?.type?.toLowerCase() === 'section' ?
                          values?.[isModalOpen?.template]?.[isModalOpen?.index]?.[isModalOpen?.data?.question_no] ||
                          (questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.find(doc => doc?.template === isModalOpen?.template)?.answer?.[isModalOpen?.index]?.find(ele => ele.question_no === isModalOpen?.data?.question_no))?.answer || '' :
                          values?.normalFields?.[isModalOpen?.data?.question_no] ||
                          (questions?.docs_answers?.length > 0 &&
                            questions?.docs_answers?.find(doc => doc?.question_no === isModalOpen?.data?.question_no)?.answer) || ''}
                      </ParagraphComp>
                      {/* Input Types Handling */}
                      {['text', 'number', 'date', 'password', 'float'].includes(isModalOpen?.data?.type.toLowerCase()) && (
                        <div className="mt-[20px]">
                          <CustomInput
                            required
                            type={isModalOpen?.data?.type?.toLowerCase()}
                            name={isModalOpen?.data?.question_no}
                            value={modalValues?.[isModalOpen?.data?.question_no]}
                            onChange={handleChange}
                            label="New Answer"
                          />
                          <ParagraphComp className="text-[red] text-[10px] px-[8px] mt-1" text={modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>
                      )}

                      {isModalOpen?.data?.type.toLowerCase() === 'dropdown' && (
                        <div className="mt-[20px]">
                          <CustomSelection
                            imgKey="flag"
                            exDataKey={isModalOpen?.data?.question === 'Country Code' ? 'label' : undefined}
                            mappingKey={isModalOpen?.data?.question === 'Country Code' ? 'phone' : undefined}
                            options={isModalOpen?.data?.question === 'Country Code' ? allCountries : isModalOpen?.data?.options}
                            required
                            value={modalValues?.[isModalOpen?.data?.question_no]}
                            onChange={handleChange}
                            name={isModalOpen?.data?.question_no}
                            label="New Answer"
                          />
                          <ParagraphComp className="text-[red] text-[10px] px-[8px] mt-1" text={modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>
                      )}
                      {isModalOpen?.data?.type?.toLowerCase() === 'text area' &&
                        < div className='mt-[20px]'>
                          <CustomTextarea
                            required={true}
                            name={isModalOpen?.data?.question_no}
                            value={modalValues?.[isModalOpen?.data?.question_no]}
                            onChange={handleChange}
                            label='New Answer' />
                          <ParagraphComp className='text-[red] text-[10px] px-[8px] mt-1' text={modalValues?.[isModalOpen?.data?.question_no] && modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>}
                      {isModalOpen?.data?.type.toLowerCase() === 'multiselect dropdown' && (
                        <div className="mt-[20px]">
                          <MultipleSelect
                            required
                            options={(() => {
                              const baseOptions = isModalOpen?.data?.options || [];
                              return isModalOpen?.data?.question_no === "DRQ-00077"
                                ? baseOptions.filter(ele => values?.['DRQ-00076']?.includes(ele.value))
                                : [...new Map(baseOptions.map(item => [item.value, item])).values()]; // Ensuring unique keys
                            })()}
                            maxSelect={isModalOpen?.data?.validation === 'Select Upto 3' ? 3 : undefined}
                            mappingKey="option"
                            onValueChange={(name, values) => modalMultiSelectedValues(name, values, setModalFieldValue)}
                            selectedValues={modalValues?.[isModalOpen?.data?.question_no] || []}
                            name={isModalOpen?.data?.question_no}
                            label="New Answer"
                          />
                          <ParagraphComp className="text-[red] text-[10px] px-[8px] mt-1" text={modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>
                      )}

                      {isModalOpen?.data?.type.toLowerCase() === 'attach' && (
                        <div className="mt-[20px]">
                          <CustomFileInput
                            required
                            onChange={(e) => attachFile(e, setModalFieldValue)}
                            value={modalValues?.[isModalOpen?.data?.question_no]?.file_name}
                            name={isModalOpen?.data?.question_no}
                            label="New Answer"
                          />
                          <ParagraphComp className="text-[red] text-[10px] px-[8px] mt-1" text={modalErrors?.[isModalOpen?.data?.question_no]} />
                        </div>
                      )}

                      {/* Save Button */}
                      <div className="flex justify-center mt-[15px]">
                        <ButtonComp disabled={editLoading} className="w-[150px] rounded-full bg-[#004878] p-[6px] text-white border-none" type="Submit" text={editLoading ? "Saving..." : "Save"} />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>

            </ModalComp>
          </Form>
        )}
      </Formik >
    </>
  );
};

export default ExternalReferences;
